import {GenRestorationMetrics} from '../../generated/serverModels/GenRestorationMetrics';
import moment from 'moment';
import {signal, Signal} from '@angular/core';

export class RestorationMetric extends GenRestorationMetrics {

  public startDate: moment.Moment;
  public endDate: moment.Moment;

  public restorationTimes: {[restorationPercent: number]: moment.Moment};
  public testRestorationTimes: Map<number, number>;
  public phenomNames: Signal<string>;

  constructor(metric?: RestorationMetric) {
    super(metric);


    if(metric) {
      this.startDate = this.peakTime.clone().subtract(this.impactDuration, 'minutes');
      this.endDate = this.startDate.clone().add(this.eventDuration, 'minutes');


      this.testRestorationTimes = new Map([
        [0, this.res0],
        [20, this.res20],
        [40, this.res40],
        [60, this.res60],
        [80, this.res80],
        [100, this.res100],
      ]);

      this.restorationTimes = {
        0: this.peakTime.clone().add(this.res0, 'hours'),
        20: this.peakTime.clone().add(this.res20, 'hours'),
        40: this.peakTime.clone().add(this.res40, 'hours'),
        60: this.peakTime.clone().add(this.res60, 'hours'),
        80: this.peakTime.clone().add(this.res80, 'hours'),
        100: this.peakTime.clone().add(this.res100, 'hours'),
      };

      if(metric.weatherPhenoms) {
        this.phenomNames = signal(this.weatherPhenoms.map(phenom => phenom.displayName)
          .sort((a,b)=> {
            if (a.toLowerCase() > b.toLowerCase()) return 1;
            if (a.toLowerCase() < b.toLowerCase()) return -1;
            return 0;
          })
          .join(', '));
      }

    }

  }

}
